import React from 'react';

import { PageLoader } from '@/views/component/Loader';
import { TEST_IDS } from '@/constants';

import styles from './Splash.module.scss';

const Splash = () => (
	<div className={styles.container} data-id={TEST_IDS.SPLASH_CONTAINER}>
		<PageLoader />
	</div>
);

export default Splash;
